module.exports = __webpack_public_path__ + "static/media/when_green_flag.e6c0935d.png";